export function arrayLen(val: any[]): number {
  try {
    return val.length;
  } catch (e) {
    return 0;
  }
}
